import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const CheckFilledSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M5.405 8.038a.6.6 0 1 0-.81.884l2 1.834a.6.6 0 0 0 .846-.036l3.902-4.225a.6.6 0 0 0-.882-.814L6.965 9.467z"
      clipRule="evenodd"
    />
  </IconV2>
);

export default CheckFilledSmallIcon;
